import DonationController from "../controller/DonationController";



class Donations{

    constructor(){

        this.donationController = new DonationController(); //Donation Controller
    }


    /**
     * 
     * GET DONATIONS LIST
     */
    async getDonations(){

        let response= await this.donationController.getDonations();

        //API call error
        if(response === undefined){
            return undefined;
        }
        //Connection KO
        if (!response.donations){
            return undefined;

        }
        //Connection OK
        else{
            //return await response.donations;
            let _ = require('underscore');
            var donations = await response.donations;
           
            var out_donations = [];

            //format data
            _.each(donations, function(donation){
                //console.log(donation);
                var out_donation={};
                
                out_donation['id'] = donation['ID'];
                out_donation['date'] = donation['date'];
                out_donation['nom'] = donation['lname'];
                out_donation['prenom'] = donation['fname'];
                out_donation['mail'] = donation['email'];
                out_donation['montant'] = donation['total'];
                out_donation['mode'] = donation['gateway'];
                out_donation['status'] = donation['status'];
                out_donation['devise'] = donation['payment_meta']['_give_payment_currency'];
                out_donation['type_don'] = donation['payment_meta']['give_type_message'];
                out_donation['recu_fiscal'] = donation['payment_meta']['give_recu_fiscal'];
                out_donation['billing_address1'] = donation['payment_meta']['_give_donor_billing_address1'];
                out_donation['billing_address2'] = donation['payment_meta']['_give_donor_billing_address2'];
                out_donation['billing_city'] = donation['payment_meta']['_give_donor_billing_city'];
                out_donation['billing_zip'] = donation['payment_meta']['_give_donor_billing_zip'];


                
                out_donations.push(out_donation);
            });
            //debugger;
            return out_donations;

        }

        

    }


    /**
     * 
     * GET DONATION BY ID
     */
     async getDonationByID(id){

        let response= await this.donationController.getDonationByID(id);

        //API call error
        if(response === undefined){
            return undefined;
        }
        //Connection KO
        if (!response.donations){
            return undefined;

        }
        //Connection OK
        else{
            //return await response.donations;
            let _ = require('underscore');
            var donations = await response.donations;

            var out_donations = [];
            
            //format data
            _.each(donations, function(donation){
                //console.log(donation);
                var out_donation={};
                
                out_donation['id'] = donation['ID'];
                out_donation['date'] = donation['date'];
                out_donation['nom'] = donation['lname'];
                out_donation['prenom'] = donation['fname'];
                out_donation['mail'] = donation['email'];
                out_donation['montant'] = donation['total'];
                out_donation['mode'] = donation['gateway'];
                out_donation['status'] = donation['status'];
                out_donation['devise'] = donation['payment_meta']['_give_payment_currency'];
                out_donation['type_don'] = donation['payment_meta']['give_type_message'];
                out_donation['recu_fiscal'] = donation['payment_meta']['give_recu_fiscal'];
                out_donation['billing_address1'] = donation['payment_meta']['_give_donor_billing_address1'];
                out_donation['billing_address2'] = donation['payment_meta']['_give_donor_billing_address2'];
                out_donation['billing_city'] = donation['payment_meta']['_give_donor_billing_city'];
                out_donation['billing_zip'] = donation['payment_meta']['_give_donor_billing_zip'];
                
                out_donations.push(out_donation);
                
            });
            return out_donations;

        }

        

    }


    /**
     * GET COMMENTS FROM DONATION ID
     * @param {string} id donation id 
     */
    async getDonationDonorCommentHistory(id){
        let response= await this.donationController.getDonationCommentsHistory(id);

        //API call error
        if(response === undefined){
            return undefined;
        }
        //Connection KO
        if (!response.dataArray){
            return undefined;

        }
        //Connection OK
        else{
            //return await response.donations;
            let _ = require('underscore');

            let donor_comments=_.filter(response.dataArray, function(comment){
                return comment.comment_type === "donor_donation"
            });
            
            if(donor_comments.length > 0){
                return donor_comments[0]['comment_content']
            }
            
        }


    }

}
export default Donations;